module.exports = __webpack_public_path__ + "img/reviews-10.e280b34c.jpg";